import { supabase } from '@/integrations/supabase/client';
import type { FontePrevia, PreviaCnpj } from '../../../backend/src/services/propostas/previa-cnpj';

export type { FontePrevia, ItemPrevia, PreviaCnpj } from '../../../backend/src/services/propostas/previa-cnpj';

/** A prévia de proposta do TOP de um lead CNPJ (Douglas 05/10/2026). */
export interface PreviaDoLead {
  fonte: FontePrevia;
  top: string;
  top_nome: string;
  calculado_em: string;
  previa: PreviaCnpj;
}

const BASE = () => ((import.meta.env.VITE_SUPABASE_URL as string) ?? 'https://beta.crm-api.primetecia.com.br/api').replace(/\/$/, '');

export async function buscarPreviaPropostaLead(leadId: string): Promise<PreviaDoLead | null> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Sessão expirada — faça login novamente.');
  const resp = await fetch(`${BASE()}/v1/leads-carteira/${leadId}/previa-proposta`, {
    headers: { Authorization: `Bearer ${session.access_token}` },
  });
  const corpo = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(corpo?.error || `Falha (${resp.status})`);
  return (corpo?.data ?? null) as PreviaDoLead | null;
}
